// Resolves a possibly-relative image URL to a full URL browsers can load.
// Uploaded catalog images are stored as relative paths (e.g. "/api/catalog/xxx/image-file?v=abc")
// so they work across preview + production without env-specific config.
// External URLs (https://…) are returned untouched.

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveImageUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}
